module.exports = __webpack_public_path__ + "img/empty_announcement.084b3575.png";